export default "__VITE_ASSET__Dc0h5qoW__"